import { useEffect, useRef, useState } from "react";
import { KTIcon } from "../../../../_metronic/helpers";
import { useQuery } from "react-query";
import { getTicketCurrentDetailed } from "../../../api/match/matchApi";

const TicketInPersonForm = ({ formik, labels, loading }) => {
  const [isMale, setIsMale] = useState<boolean>(true);
  const [attendees, setAttendees] = useState([
    {
      name: "",
      mobile: "",
      national_code: "",
      male: true,
    },
  ]);
  const genderOptions = [
    { id: "female", name: "زن" },
    { id: "male", name: "مرد" },
  ];

  const { data: tickets, refetch } = useQuery(["getProfilePlatforms"], () =>
    getTicketCurrentDetailed(isMale)
  );

  useEffect(() => {
    refetch();
  }, [isMale]);

  useEffect(() => {
    formik.setFieldValue("attendees", attendees);
  }, [attendees]);

  const addAttendee = () => {
    if (attendees.length < 5) {
      setAttendees((prev) => [
        ...prev,
        {
          name: "",
          mobile: "",
          national_code: "",
          male: isMale,
        },
      ]);
    }
  };

  const removeAttendee = () => {
    if (attendees.length > 1) {
      setAttendees((prev) => prev.slice(0, -1));
    }
  };

  const checkErrors = () => {
    return Object.values(formik.errors).length > 0;
  };

  const handleInputChange = (index, field, value) => {
    const updatedAttendees = [...attendees];
    updatedAttendees[index][field] = value;
    setAttendees(updatedAttendees);
  };

  useEffect(() => {
    if (tickets?.data?.profile?.profilePlatforms?.length > 0) {
      formik.setFieldValue(
        "profilePlatformId",
        tickets?.data?.profile?.profilePlatforms[0]?.id
      );

      formik.setFieldValue("matchId", tickets?.data?.id);
    }
  }, [tickets]);

  const addAttendeeRef = useRef(null);

  const handleSubmit = async (event) => {
    event.preventDefault();

    formik.validateForm();
    if (Object.keys(formik.errors).length > 0) {
      return;
    }

    await formik.handleSubmit();
  };

  return (
    <>
      {/* <div className="card-body">
        <div className="form-label fw-bold">اضافه / حذف کردن هوادار</div>
        <div
          className="relative w-50 border"
          style={{
            height: "50px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <button
            ref={addAttendeeRef}
            className="absolute btn btn-primary"
            onClick={addAttendee}
          >
            +
          </button>
          <span>{attendees.length}</span>
          <button className="absolute btn btn-primary" onClick={removeAttendee}>
            -
          </button>
        </div>
      </div> */}
      <form onSubmit={handleSubmit} className="form">
        <div className="card-body">
          <div className="row row-gap-10 mb-6">
            <div className="col-12 col-lg-6">
              <label htmlFor="" className="form-label fw-bold">
                جنسیت
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                onChange={(e) => {
                  setIsMale(e.target.value === "male");
                }}
              >
                {genderOptions.map((option, index) => (
                  <option
                    selected={option?.id === "female" ? false : true}
                    value={option?.id}
                    key={index}
                  >
                    {option?.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="row row-gap-10 mb-6">
            {tickets &&
              tickets?.data?.profile?.profilePlatforms?.length > 0 && (
                <div className="col-12 col-lg-6">
                  <label htmlFor="" className="form-label fw-bold">
                    انتخاب جایگاه
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => {
                      formik.setFieldValue(
                        "profilePlatformId",
                        Number(e.target.value)
                      );
                    }}
                  >
                    {tickets.data.profile.profilePlatforms.map(
                      (ticket, index) => (
                        <option
                          value={ticket.id}
                          key={index}
                          selected={
                            formik?.values?.profilePlatformId === ticket?.id
                          }
                        >
                          {ticket?.platform?.name} (ظرفیت:{" "}
                          {ticket?.remainedCapacity} نفر)
                        </option>
                      )
                    )}
                  </select>
                </div>
              )}
          </div>
          {attendees.map((attendee, index) => (
            <div className="row mb-5" key={index}>
              <div className="col-lg-4 mb-1">
                <label className="form-label fw-bold">نام و نام خانوادگی</label>
                <input
                  className="form-control form-control-lg form-control-solid"
                  value={attendee.name}
                  onChange={(e) =>
                    handleInputChange(index, "name", e.target.value)
                  }
                  onBlur={() =>
                    formik.setFieldTouched(`attendees[${index}].name`, true)
                  }
                />
                {formik.touched.attendees?.[index]?.name &&
                  formik.errors.attendees?.[index]?.name && (
                    <div className="text-danger">
                      {formik.errors.attendees[index].name}
                    </div>
                  )}
              </div>

              <div className="col-lg-4 mb-1">
                <label className="form-label fw-bold">کد ملی</label>
                <input
                  className="form-control form-control-lg form-control-solid"
                  value={attendee.national_code}
                  onChange={(e) =>
                    handleInputChange(index, "national_code", e.target.value)
                  }
                  onBlur={() =>
                    formik.setFieldTouched(
                      `attendees[${index}].national_code`,
                      true
                    )
                  }
                />
                {formik.touched.attendees?.[index]?.national_code &&
                  formik.errors.attendees?.[index]?.national_code && (
                    <div className="text-danger">
                      {formik.errors.attendees[index].national_code}
                    </div>
                  )}
              </div>

              <div className="col-lg-4 mb-1">
                <label className="form-label fw-bold">شماره موبایل</label>
                <input
                  className="form-control form-control-lg form-control-solid"
                  value={attendee.mobile}
                  onChange={(e) =>
                    handleInputChange(index, "mobile", e.target.value)
                  }
                  onBlur={() =>
                    formik.setFieldTouched(`attendees[${index}].mobile`, true)
                  }
                />
                {formik.touched.attendees?.[index]?.mobile &&
                  formik.errors.attendees?.[index]?.mobile && (
                    <div className="text-danger">
                      {formik.errors.attendees[index].mobile}
                    </div>
                  )}
              </div>
            </div>
          ))}
          <div className="mt-4">
            <button
              type="submit"
              className="btn btn-primary d-flex align-items-center gap-2"
              disabled={loading || checkErrors()}
            >
              {loading ? "در حال ارسال..." : labels.sendBtnLabel}
              <span>
                <KTIcon iconName={"send"} className={"fs-2"} />
              </span>
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default TicketInPersonForm;
